import { c as _c } from "react/compiler-runtime";
import { Button, Modal } from '@common/components';
import { useToast } from '@common/hooks';
import { cn } from '@core/utils';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
interface CouponCancelModalProps {
  opened: boolean;
  onClose: () => void;
}
export const CouponCancelModal = t0 => {
  const $ = _c(20);
  const {
    opened,
    onClose
  } = t0;
  const {
    toast
  } = useToast();
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP);
  if (!opened) {
    return null;
  }
  let t1;
  if ($[0] !== onClose || $[1] !== toast) {
    t1 = () => {
      toast({
        message: "\uAD6C\uB9E4\uCDE8\uC18C\uAC00 \uC644\uB8CC\uB418\uC5C8\uC5B4\uC694. \uB0B4\uC5ED\uC5D0\uC11C \uD655\uC778\uAC00\uB2A5\uD574\uC694."
      });
      onClose();
    };
    $[0] = onClose;
    $[1] = toast;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleCouponCancel = t1;
  const t2 = isDesktop ? "H56" : "H48";
  let t3;
  if ($[3] !== onClose || $[4] !== t2) {
    t3 = <Button theme="sub-fill" dimensions={t2} onClick={onClose} className="flex-1 whitespace-nowrap">닫기</Button>;
    $[3] = onClose;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = isDesktop ? "H56" : "H48";
  let t5;
  if ($[6] !== handleCouponCancel || $[7] !== t4) {
    t5 = <Button theme="primary-fill" dimensions={t4} className="flex-1 whitespace-nowrap" onClick={handleCouponCancel}>취소하기</Button>;
    $[6] = handleCouponCancel;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="flex gap-8">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p> </p>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className={cn("pb-16 font-800 text-Gray-900 typo-h5", "mobile-tablet:pb-8 mobile-tablet:font-700 mobile-tablet:typo-body2")}>주문을 취소하시겠어요?</p>;
    t9 = cn("font-400 text-Gray-700 typo-body2", "mobile-tablet:typo-body3");
    $[13] = t8;
    $[14] = t9;
  } else {
    t8 = $[13];
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="max-w-[26rem] pt-12">{t8}<p className={t9}>구매취소는 구매일로부터<br className="hidden mobile-tablet:block" /><span className="mobile-tablet:hidden"> </span>30일까지만 가능해요.</p></div>;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== onClose || $[17] !== opened || $[18] !== t6) {
    t11 = <Modal opened={opened} onClose={onClose} closeButton={true} buttonFooter={t6} header={t7}>{t10}</Modal>;
    $[16] = onClose;
    $[17] = opened;
    $[18] = t6;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
};